import { render, staticRenderFns } from "./addDegreeSubject.vue?vue&type=template&id=ec681b7c&scoped=true&"
import script from "./addDegreeSubject.vue?vue&type=script&lang=js&"
export * from "./addDegreeSubject.vue?vue&type=script&lang=js&"
import style0 from "./addDegreeSubject.vue?vue&type=style&index=0&id=ec681b7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec681b7c",
  null
  
)

export default component.exports